import React from 'react';

import { Grid } from '@gogame/components';
import { FormFieldArray, useSiblingFieldName } from '@gogame/form';

import { RewardsPicker } from 'scenes/PromoCodes/components/PromoCodesForm/components';

import { Reward } from './Reward';

const Rewards = ({ name, disabled, data, loading }) => {
  const getName = useSiblingFieldName();
  return (
    <FormFieldArray name={getName(name)}>
      {({ value, push, error, remove }) => {
        return (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <RewardsPicker
                value={value}
                options={data || []}
                onChange={(_e, v) => push(v)}
                error={error}
                disabled={disabled}
                loading={loading}
              />
            </Grid>
            {value &&
              value?.map((reward, i) => (
                <Grid item xs={4} key={`${i}`}>
                  <Reward
                    name={`${name}[${i}]`}
                    label={reward.name}
                    maxValue={reward.maxValue}
                    isCompensationSupported={
                      reward.isCompensationSupported || reward.compensations
                    }
                    onRemove={() => remove(i)}
                  />
                </Grid>
              ))}
          </Grid>
        );
      }}
    </FormFieldArray>
  );
};

export default Rewards;
